import { graphql } from "@/gql";

export const relocationsByCityQuery = graphql(`
  query RelocationsByCity($supplierIds: [ID!]) {
    relocationsByCity(supplierIds: $supplierIds) {
      city {
        id
        name
        lat
        lng
      }
      count
      deliveryCities {
        count
        city {
          id
          name
          lat
          lng
        }
      }
    }
  }
`);
